import { PAYMENT_GATEWAYS_API } from 'modules/profile/payment-gateways/api/payment-gateways-api'
import httpClient from 'shared/utils/http-client'

export const stripeDisconnect = () => httpClient.post(`${PAYMENT_GATEWAYS_API}/stripe/disconnect`)
